"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var uniqueId_1 = __importDefault(require("../../../util/uniqueId"));
var react_1 = require("react");
function Grimace() {
    var path1 = react_1.useMemo(function () { return uniqueId_1.default('react-path-'); }, []);
    var mask1 = react_1.useMemo(function () { return uniqueId_1.default('react-mask-'); }, []);
    return (jsx_runtime_1.jsxs("g", __assign({ transform: 'translate(2.000000, 52.000000)' }, { children: [jsx_runtime_1.jsx("defs", { children: jsx_runtime_1.jsx("rect", { id: path1, x: '24', y: '9', width: '60', height: '22', rx: '11' }, void 0) }, void 0),
            jsx_runtime_1.jsx("rect", { fillOpacity: '0.599999964', fill: '#000000', fillRule: 'evenodd', x: '22', y: '7', width: '64', height: '26', rx: '13' }, void 0),
            jsx_runtime_1.jsx("mask", __assign({ id: mask1, fill: 'white' }, { children: jsx_runtime_1.jsx("use", { xlinkHref: '#' + path1 }, void 0) }), void 0),
            jsx_runtime_1.jsx("use", { fill: '#FFFFFF', fillRule: 'evenodd', xlinkHref: '#' + path1 }, void 0),
            jsx_runtime_1.jsx("path", { fill: '#E6E6E6', fillRule: 'evenodd', mask: "url(#" + mask1 + ")", d: 'M71,22 L62,22 L62,34 L58,34 L58,22 L49,22 L49,34 L45,34 L45,22 L36,22 L36,34 L32,34 L32,22 L24,22 L24,18 L32,18 L32,6 L36,6 L36,18 L45,18 L45,6 L49,6 L49,18 L58,18 L58,6 L62,6 L62,18 L71,18 L71,6 L75,6 L75,18 L83.8666667,18 L83.8666667,22 L75,22 L75,34 L71,34 L71,22 Z' }, void 0)] }), void 0));
}
exports.default = Grimace;
